<main class="dashboard-layout bg-neutral">
  <header #headerContainer class="page-header-container">
    <ng-container *ngIf="headerBgConfig | async as bgConfig">
      <app-card
        let
        bgConfig
        height="100%"
        [backgroundColor]="
          'linear-gradient(90deg, ' +
          bgConfig.mainColor +
          ' 0%,' +
          bgConfig.secondaryColor +
          ' 100%)'
        "
        borderRadius="0px"
        padding="20px 70px"
        boxShadow="rgba(0, 0, 0, .2) 0px 4px 3px"
      >
        <article class="d-flex align-items-center h-100" card__content>
          <section class="d-flex justify-content-between w-100">
            <div class="h-100 row align-items-center">
              <div class="col d-flex flex-row align-items-center">
                <button
                  *ngIf="hasBackButton"
                  class="btn-back-header"
                  (click)="goBack()"
                  [style]="{ color: bgConfig.fontColor, borderColor: bgConfig.fontColor }"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <app-svg-icon
                  [iconName]="headerTitleIcon"
                  [fillColor]="bgConfig.fontColor"
                >
                </app-svg-icon>
                <h1
                  class="font-24 font-primary--eb ms-4"
                  [style]="{ color: bgConfig.fontColor }"
                >
                  {{ headerTitle }}
                </h1>
              </div>
            </div>
            <section *ngIf="headerButtonText || headerRefreshButtonText || canViewWellness">
              <div class="header-right" [class.with-wellness]="canViewWellness && wellnessEnabled">
                  <button *ngIf="headerButtonText" class="btn-create-class" (click)="emitHeaderButton()"  [style]="{ color: bgConfig.mainColor }">
                      <svg viewBox="0 0 24 24" fill="none">
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                    {{ headerButtonText }}
                  </button>
                  <button *ngIf="headerRefreshButtonText" class="btn-create-class" (click)="emitRefreshButton()" [style]="{ color: bgConfig.mainColor }">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="23 4 23 10 17 10"></polyline>
                      <polyline points="1 20 1 14 7 14"></polyline>
                      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                    </svg>
                    {{ headerRefreshButtonText }}
                  </button>

                  <app-wellness-notifications *ngIf="canViewWellness" [class.with-wellness]="canViewWellness && wellnessEnabled"></app-wellness-notifications>

              </div>
            </section>
          </section>
        </article>
      </app-card>
    </ng-container>
  </header>

  <!-- Wellness badge positioned outside header for proper z-index stacking -->
  <div *ngIf="canViewWellness && wellnessEnabled" class="wellness-badge">
    <img
      src="assets/images/logos/wellness-logo.svg"
      alt="Wellness"
      class="wellness-logo"
    />
    <div class="wellness-badge-triangle"></div>
  </div>
  <div style="height: 50px; visibility: hidden"></div>

  <section class="content-container">
    <section class="content-wrapper">
      <router-outlet></router-outlet>
    </section>
  </section>

  <app-modern-drawer></app-modern-drawer>
  <ng-container *ngIf="footerConfig">
    <app-creational-pages-footer
      [footerConfig]="footerConfig"
      [windowResizeListener]="windowResizeListener"
      [transitionInConfig]="transitionInConfig"
      [transitionOutConfig]="transitionOutConfig"
    ></app-creational-pages-footer>
  </ng-container>
</main>
